class Classroom {
	id = null;
	name = '';
	office_id = null;
	capacity = null;
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Classroom;
